var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('text-hero-section',{staticClass:"text-hero-section-module",attrs:{"title":_vm.attributes.textHero_title,"text":_vm.attributes.textHero_text}})}
var staticRenderFns = []

export { render, staticRenderFns }